/*
 *-- Related to paths for the navigation
 */

import * as routing from './routingConstants';

const US_ALPHA2_CODE = 'US';

export { routing, US_ALPHA2_CODE };
